import {
  Card,
  Divider,
  FlatActionList,
  FlatActionListItem,
  TextButton,
} from "@towersystems/roam-common-native";
import { View } from "react-native-ui-lib";
import SaleItem from "../../../../../utilities/data/model/SaleItem";
import { EditCartItemModalScreenProps, ProductState } from "../types";

export type OtherListCardProps = Pick<
  EditCartItemModalScreenProps,
  "navigation" | "route"
> & {
  item: SaleItem;
  productState: ProductState;
};

export function OtherListCard({ item, navigation }: OtherListCardProps) {
  let otherActionItems: FlatActionListItem[] = [
    {
      key: "editNote",
      title: "Customer Note",
      subTitle: item.customerNote,
      onPress: () => {
        navigation.navigate("EditCartItemNoteScreen");
      },
    },
  ];

  if (item.serialNumber) {
    otherActionItems.push({
      key: "editSerialNumbers",
      title: "Serial Number",
      onPress: () => {
        navigation.navigate("EditSerialNumberScreen");
      },
      componentRight(icon: any) {
        return (
          <View style={{ alignItems: "center" }} row>
            <TextButton
              onPress={() => {
                navigation.navigate("EditSerialNumberScreen");
              }}
            >
              {item.serialNumber || ""}
            </TextButton>
          </View>
        );
      },
    });
  }

  if (!otherActionItems.length) {
    return null;
  }

  return (
    <>
      <Divider style={{ marginTop: 60, marginBottom: 40 }} />
      <Card titlePosition="outside" title="Other">
        <FlatActionList items={otherActionItems} />
      </Card>
    </>
  );
}
